import DocumentsSchemasRequest from '../ws/schemes/DocumentsSchemasRequest';
import SchemeDocumentRequest from '../ws/schemes/SchemeDocumentRequest';
import TypeDocumentsRequest from '../ws/TypeDocumentsRequest';
import Alert from 'react-s-alert';
import { push } from 'react-router-redux';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { PsRoutes } from '../../shared/routing/Routes';
import AddSchemeDocumentRequest from '../ws/schemes/AddSchemeDocumentRequest';
import UpdateSchemeDocumentRequest from '../ws/schemes/UpdateSchemeDocumentRequest';
import { reset } from 'redux-form';

export const SCHEME_DOCUMENTS_UPDATE = 'scheme-documents-update';
export const SCHEME_DOCUMENTS_LOADING = 'scheme-documents-loading';
export const SCHEME_DOCUMENTS_ERROR = 'scheme-documents-error';
export const SCHEME_DOCUMENT_UPDATE = 'scheme-document-update';
export const SCHEME_DOCUMENT_LOADING = 'scheme-document-loading';
export const SCHEME_TYPE_DOCUMENTS = 'scheme-type-documents';

export const getSchemesDocuments = (page = 1, search = '', filter = 0) => (dispatch) => {

    new DocumentsSchemasRequest(filter, page, search)
        .onPreExecution(() => {
            dispatch({type: SCHEME_DOCUMENTS_LOADING, payload: true});
        })
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: SCHEME_DOCUMENTS_UPDATE,
                payload: data,
            });
        })
        .onFail(error => {
            dispatch({type: SCHEME_DOCUMENTS_ERROR, payload: error});
        })
        .onPostExecution(() => {
            dispatch({type: SCHEME_DOCUMENTS_LOADING, payload: false});
        })
        .execute();
};

export const getSchemaDocument = (id) => (dispatch) => {
    new SchemeDocumentRequest(id)
        .onSuccess(data => {
            dispatch({
                type: SCHEME_DOCUMENT_UPDATE,
                payload: data,
            });
        })
        .execute();
};

export const addSchemeDocument = (schemeDocument = {}) => (dispatch) => {

    new AddSchemeDocumentRequest(schemeDocument)
        .onPreExecution(() => {
            dispatch({type: SCHEME_DOCUMENT_LOADING, payload: true});
        })
        .onSuccess(data => {
            Alert.success(I18nUtils.tr('TR_ADD_SCHEME_DOCUMENT_SUCCESS'));
            dispatch({type: SCHEME_DOCUMENT_UPDATE, payload: data});
            dispatch(reset('SchemeDocumentsCreateForm'));
        })
        .onFail(error => {
            Alert.error(error || I18nUtils.tr('TR_ADD_SCHEME_DOCUMENT_ERROR'));
        })
        .onPostExecution(() => {
            dispatch({type: SCHEME_DOCUMENT_LOADING, payload: false});
        })
        .execute();
};

export const updateSchemeDocument = (schemeDocument = {}) => (dispatch) => {
    new UpdateSchemeDocumentRequest(schemeDocument.id, schemeDocument)
        .onPreExecution(() => {
            dispatch({type: SCHEME_DOCUMENT_LOADING, payload: true});
        })
        .onSuccess(data => {
            Alert.success(I18nUtils.tr('TR_UPDATE_SCHEME_DOCUMENT_SUCCESS'));
            dispatch(push(PsRoutes.MY_OUTSOURCES_DOCUMENTS_SCHEMES));
        })
        .onFail(error => {
            Alert.error(error || I18nUtils.tr('TR_UPDATE_SCHEME_DOCUMENT_ERROR'));
        })
        .onPostExecution(() => {
            dispatch({type: SCHEME_DOCUMENT_LOADING, payload: false});
        })
        .execute();
};

export const getTypeDocuments = () => (dispatch) => {

    new TypeDocumentsRequest(0, '', '', 2)
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: SCHEME_TYPE_DOCUMENTS,
                payload: data,
            });
        })
        .execute();
};



// WEBPACK FOOTER //
// ./src/app/documents/actions/schemesDocumentsActions.js